import React from 'react'
import { Flex} from 'antd'
function Title(props) {
  return (
            <Flex 
                justify='center'
                style={{fontSize:'30px',marginBottom:"20px",fontWeight:'bold',position:'relative'}}
            >
                {props.name}               
            </Flex>
  )
}

export default Title